import React from 'react';
import cs from 'classnames';

import css from './index.css';

const Point = ({text, title, className, isOrigin, onMap}) => (
  <div
    title={title}
    className={cs(css.point, isOrigin && css.origin, onMap && css.onMap, className)}
  >
    {text}
  </div>
);

export default Point;



// WEBPACK FOOTER //
// ./src/components/common/DirectionPoint/index.js